import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { ConfigProvider, Select } from 'antd';

import { toStorageLang } from '../../helpers/lang';

import Constants from '../../constants';
import { changeLang } from '../../modules/client/actions/Client';

import { AppDispatch, ReduxState } from '../../types/app';

const langSwitcherTheme = {
  hashed: false,
  cssVar: { key: 'app' },
};

type LangOptionProps = {
  lang: string;
};

const LangOption = ({ lang }: LangOptionProps) => {
  const intl = useIntl();

  return (
    <div className="lang-option">
      <img src={`/flags/${lang}.svg`} alt="" />
      <span className="lang-option__name">
        {intl.formatMessage({ id: `lang.${lang}` })}
      </span>
    </div>
  );
};

const LangSwitcher = () => {
  const intl = useIntl();
  const dispatch = useDispatch<AppDispatch>();
  const locale = useSelector((state: ReduxState) => state.intl.locale);

  const options = useMemo(
    () =>
      Constants.Langs.map((value) => ({
        value,
        label: <LangOption lang={value} />,
      })),
    []
  );

  const handleChangeLang = (lang: string) => {
    dispatch(changeLang(lang));
  };

  const selectedLang = toStorageLang(locale);

  return (
    <ConfigProvider theme={langSwitcherTheme}>
      <Select
        className="lang-switcher"
        classNames={{
          popup: {
            root: 'lang-switcher-popup',
          },
        }}
        value={selectedLang}
        options={options}
        onChange={handleChangeLang}
        popupMatchSelectWidth={false}
        suffixIcon={<span className="lang-chevron" aria-hidden />}
        aria-label={intl.formatMessage({ id: `lang.${selectedLang}` })}
      />
    </ConfigProvider>
  );
};

export default LangSwitcher;
